import { render, staticRenderFns } from "./electronicbillJRLD.vue?vue&type=template&id=1c181bc4"
import script from "./electronicbillJRLD.vue?vue&type=script&lang=js"
export * from "./electronicbillJRLD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports